<template>
    <cmpCreate ref="cmpCreate"
               v-bind:name="name"
               v-bind:pkColumn="pkColumn"
               v-bind:fields="fields"
               v-bind:parent="parent"
               v-bind:header="header"
               @inputChanged="inputChanged"></cmpCreate>
</template>

<script>
    import i18n from '@/i18n'
    import cmpCreate from "@/components/common/cmpCreate"
    import { codeName } from "@/util/constant"
    import { gmtToLocal } from '@/util/dateutil';

    export default {
        components: {
            cmpCreate
        },
        computed: {
            fields() {
                return [
                    {
                        "key": "UnitId", "label": i18n.t('component.Class.UnitName.label')
                        , input: { type: "textboxSearch", objectName: "Unit", idField: "UnitId", displayField: "UnitName", editDisplayField: "UnitName", qryFields: ["UnitNameOr", "UnitCodeOr"], displayFields: ["UnitCode", "UnitName"] }
                        , required: true
                    },
                    { "key": "ClassName", "label": i18n.t('component.Class.ClassName.label'), input: { type: "text" }, required: true },
                    { "key": "ProjectCode", "label": i18n.t('component.Class.ProjectCode.label'), input: { type: "text" } },
                    { "key": "ClassType", "label": i18n.t('component.Class.ClassType.label'), input: { type: "select", objectName: "CodeDetail", idField: "CodeNo", displayField: ["CodeNo", "CodeDisplay"], filterField: "CodeName", filterValue: codeName.ClassType } }
                ]
            },
            header() {
                return i18n.t('component.Class.insHeader')
            }
        },
        data() {

            return {
                name: "Class",
                pkColumn: "ClassId",
                parent: {}
            };
        }
    }
</script>